export default "__VITE_ASSET__CGBABYzD__"